import { useEffect } from 'react';

/** What the browser tab says when a page names nothing more specific. */
export const DEFAULT_DOCUMENT_TITLE = 'Mothership';

/** The browser tab's title for a page: its own name, or the default. */
export function documentTitle(name: string | null | undefined): string {
  const trimmed = name?.trim() ?? '';
  return trimmed === '' ? DEFAULT_DOCUMENT_TITLE : trimmed;
}

/**
 * Names the browser tab after what is on screen: a list's tab name, a record's
 * name. Leaving the page puts the default back.
 */
export function useDocumentTitle(name: string | null | undefined): void {
  useEffect(() => {
    document.title = documentTitle(name);
    return () => {
      document.title = DEFAULT_DOCUMENT_TITLE;
    };
  }, [name]);
}
